module.exports = __webpack_public_path__ + "img/teams-delete-icon.28e21997.svg";